import { TUIModel } from './uiModel';

export const uiInitialState: TUIModel = {
  height: 800,
  width: 1200
};
